import ProfileApp from './ProfileApp';

export default ProfileApp;
